const PIN_RE = /^[1-4]\d{13}$/;

/**
 * Строгая проверка ПИН (ИНН) КР:
 * - ровно 14 цифр, первая — 1..4;
 * - цифры 2–9 — существующая дата рождения ДДММГГГГ, не раньше 1900 года и не в будущем.
 */
export const isValidPin = (value?: string | null): boolean => {
  const pin = String(value ?? '').trim();

  if (!PIN_RE.test(pin)) {
    return false;
  }

  const day = Number(pin.slice(1, 3));
  const month = Number(pin.slice(3, 5));
  const year = Number(pin.slice(5, 9));
  const date = new Date(year, month - 1, day);

  const isRealDate =
    date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;

  return isRealDate && year >= 1900 && date.getTime() <= Date.now();
};
